<template>
  <div class="print-list-wrapper ">
    <!--  搜索 -->
    <div class="input">
      <van-icon class="searchIcon" :name="searchIcon" size="0.64rem" />
      <van-field
        class="searchInput"
        v-model="search"
        input-align="left"
        placeholder="请输入要搜索单据的关键字"
      />
    </div>
    <!-- 列表 -->
    <van-list
      class="list-content"
      v-model="loading"
      :finished="finished"
      :finished-text="finishedText"
      @load="onLoad"
    >
      <router-link
        v-for="(item,index) in list"
        :key="index"
        tag="div"
        class="scroll-view-item"
        :to="{name:'printDetail', query: {file: item.fileUrl, platform: item.platform, busKey: item.instanceId} }"
      >
        <!-- <ax-exp-cell :axDate="item"></ax-exp-cell> -->
        <div :class="{'item': true, 'borderRadius': index == list.length-1}">
          <div :class="['status', item.platform, {'platform': platformObj[item.platform]}]">{{platformObj[item.platform] || '其他'}}</div>
          <div :class="{'info': true, 'noBorder': index==0}">
            <div class="title van-ellipsis">{{item.title}}</div>
            <p class="num">NO.{{item.billNo}}</p>
             <!--<em class="more">
              <van-icon :name="arrowIcon" size="0.43rem" />
            </em>
            <em class="dark-more">
              <van-icon :name="arrowDarkIcon" size="0.43rem" />
            </em>-->
          </div>
        </div>
      </router-link>
      <!-- <van-cell v-for="item in list" :key="item" :title="item">
        <div class="li-title van-ellipsis">打印你说打印你说的话副驾驶的肺结核束带结发的话副驾驶的肺结核束带结发</div>
        <p class="num">NO.20192232323</p>
        <em class="more"></em>
      </van-cell>-->
    </van-list>
  </div>
</template>

<script>
import searchIcon from '@/assets/img/icon/search.png'
import arrowIcon from '@/assets/img/icon/arrow-right.png'
import arrowDarkIcon from '@/assets/img/icon/arrow-right-dark.png'
import AxCell from '@/components/common/AxCell.vue';
import { printList } from '@/api/print'
export default {
  components: {
    "ax-exp-cell": AxCell
  },
  data() {
    return {
      searchIcon,
      arrowIcon,
      arrowDarkIcon,
      timeFlag: false,
      headName: '',
      search :'',
      loading:false,
      list: [],
      finished: false,
      isSearch: false,
      // finishedText: '没有更多了',
      platform: '',
      pageSize: 10,
      pageNum: 1,
      platformObj: {
        SSC: '共享服务',
        exp: '费用报销',
        EXP: '费用报销',
      }
    }
  },
  watch: {
    search(){
      this.gotoSearch();
      if(!this.search) {
        // this.pageNum = 1;
        this.isSearch = false;
        this.onLoad();
      } ;
    },
    "$route"(){
      this.getOrSetRouter();
    }
  },
  computed:{
    finishedText(){
      return (this.isSearch && !this.list.length) ? '暂无数据': '没有更多了'
    }
  },
  mounted(){
    if(iqh.toggleRefresh){
      iqh.toggleRefresh({isOpen: 1}) // 打开下拉刷新
    }
    this.getOrSetRouter();
  },
  destroyed(){
    if(iqh.toggleRefresh){
      iqh.toggleRefresh({isOpen: 0}) // 关闭下拉刷新
    }
  },
  methods: {
    getOrSetRouter(){
      this.platform = this.$route.query.platform;
      this.headName = this.$route.query.headName || '';
      this.$setIosTitle(this.headName+ '相关表单');
    },
    onLoad(){
        let data = {
          title: this.search,
          platform: this.platform ? this.platform : this.$route.query.platform,
          // pageSize: this.pageSize,
          // pageNum: this.pageNum
        }
        printList(data).then(({data}) => {
          if(data.code == 200){
            this.list = data.data.list;
            this.finished = true;
          }
        }).finally(() => {
           this.loading = false;
           this.finished = true;
        })
    },
    gotoSearch(){
      clearTimeout(this.timeFlag);
      this.timeFlag = setTimeout(() => {
        if(!this.search) {
          return;
        } ;
        // this.pageNum = 1;
        this.isSearch = true;
        this.loading = true;
        this.finished = false;
        this.onLoad();
      }, 500);
    },
    
  }
}
</script>
<style lang="scss" scoped>

.print-list-wrapper {
  /* padding: 10px 10px 0; */
  padding-top: 10px;
  box-sizing: border-box;
  min-height: 100vh;
  .van-list__finished-text {
    font-size: 12px;
  }
  .input {
    margin: 0 8px;
    background: #FEFEFE;
    border-radius: 4px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    color: #aaaaaa;
    letter-spacing: -0.34px;
    line-height: 22px;
    position: relative;
    .searchIcon {
      position: absolute;
      top: 6px;
      left: 10px;
      z-index: 33;
    }
    .searchInput {
      width: 311px;
      margin-left: 35px;
      z-index: 3;
      padding: 6px 9px;
      font-size: 14px;
    }
  }
  .list-content {
    /* padding-left: 10px; */
    margin-top: 10px;
    // border-radius: 8px;
    overflow: hidden;
  }

  .item {
    position: relative;
    background: #fff;
    cursor: pointer;
    &.borderRadius {
      // border-radius: 0 0 8px 8px;
    }
    .status {
      width: 48px;
      height: 48px;
      position: absolute;
      top: 16px;
      left: 16px;
      font-size: 15px;
      color: #ffffff;
      letter-spacing: 0.17px;
      line-height: 48px;
      background: $link-a;
      border-radius: 4px;
      box-sizing: border-box;
      letter-spacing: 4px;
      text-align: center;
      padding-left: 4px;
      &.platform {
        line-height: 20px;
        padding-top: 4px;
      }
      &.EXP,
      &.exp {
        background:$value-des-color;
      }
      &.SSC {
        background:#1485EE;
      }
      // &:after,
      // &:before {
      //   content: "";
      //   position: absolute;
      //   width: 14px;
      //   height: 14px;
      //   right: 0;
      //   top: 0;
      //   display: block;
      //   background: rgba(255, 255, 255, 0.6);
      //   border-radius: 0 6px;
      // }
      // &:after {
      //   width: 20px;
      //   height: 20px;
      //   right: -10px;
      //   top: -10px;
      //   background: #fff;
      //   border-radius: 0;
      //   transform: rotate(-45deg);
      // }
    }
    .info {
      padding: 16px 24px 17px 0px;
      margin-left: 76px;
      border-top: 1px solid $border-color;
      position: relative;
      &.noBorder {
        border: none;
      }
    }
    .dark-more,
    .more {
      position: absolute;
      right: 10px;
      top: 50%;
      margin-top: -0.215rem;
    }
    .dark-more {
      display: none;
    }
    .title {
      font-size: 16px;
      color: $value-color;
      letter-spacing: 0.21px;
      line-height: 22px;
      width: calc(100% - 13px);
    }
    .num {
      font-size: 12px;
      color: $title-color;
      letter-spacing: 0.16px;
      line-height: 17px;
      margin-top: 4px;
    }
  }
}

@mixin list-dark {
  .item,
  .input {
    background: #1a1a1a;
  }
  .searchInput {
    background: #1a1a1a;
    .van-field__control {
      color: #ddd;
    }
  }
  .item {
    .status:after {
      background: #1a1a1a;
    }
    .title {
      color: #ddd;
    }
    .num {
      color: #666;
    }
    .info {
      border-color: #333;
    }
    .more {
      display: none;
    }
    .dark-more {
      display: inline;
    }
  }
}
</style>

<style lang="scss">
@mixin searchInput {
  .searchInput {
    .van-field__control {
      color: #ddd;
    }
  }
}
.print-list-wrapper {
  .van-field__control{
    color: $value-color;
  }
  ::placeholder{
    color: $title-color;
  }
}

</style>